export default function useAdminPartner(props) {
  return {};
}
